export enum Instrument {
  stock = 'stock',
  forex = 'forex',
  crypto = 'crypto',
  futures = 'futures',
}

export type InstrumentType = keyof typeof Instrument

export type RecordType = Record<string | number | symbol, unknown>

export type PartialBy<Obj, Keys extends keyof Obj> = Omit<Obj, Keys> & Partial<Pick<Obj, Keys>>
